// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__B1rm6","inputWrap":"styles_inputWrap__YrxYl","input":"styles_input__1Dga3"};